export default __webpack_public_path__ + "static/sobre-tecalis_03-fa6f01dac962bc0801116136d5fb99c8.png";